import { SourcingService } from 'api-clients/monolith';
import { PropsWithChildren } from 'react';
import { FormattedMessage } from 'react-intl';

import { Typography } from '@/components/ui/typography';
import { useHiringGoalIdParam } from '@/hooks/use-hiring-goal-id-param';
import { queryKeys } from '@/query-keys';

import { AggregateBreakdownHoverCard } from './aggregate-breakdown-hover-card';

interface HiringOpeningsHoverCardProps extends PropsWithChildren {
  openingSlug: string;
}

export function HiringOpeningsHoverCard({
  children,
  openingSlug,
}: HiringOpeningsHoverCardProps) {
  const { hiringGoalId } = useHiringGoalIdParam();

  return (
    <AggregateBreakdownHoverCard
      query={{
        queryKey: [
          ...queryKeys.dashboard.hiringOpenings,
          openingSlug,
          hiringGoalId,
        ],
        queryFn: () =>
          SourcingService.getInternalApiSourcingOpeningsHiringOpenings(
            openingSlug,
            hiringGoalId,
          ),
        select: data => data.hiring_openings,
      }}
      boundary="dashboard.hiring-openings-hover-card"
      description={
        <FormattedMessage
          defaultMessage="This number is the aggregate of multiple openings within the hiring workflow. The breakdown is below."
          description="Intro for per-opening hire counts when goals are linked"
        />
      }
      valueHeader={
        <FormattedMessage
          defaultMessage="Hires"
          description="Hover card: hires count for a linked opening"
        />
      }
      renderRow={opening => (
        <>
          <Typography variant="body1" className="!text-fx-neutral-600 w-[90%]">
            {opening.title}
          </Typography>
          <Typography variant="body2" className="!text-fx-neutral-600">
            {opening.hire_count}
          </Typography>
        </>
      )}
    >
      {children}
    </AggregateBreakdownHoverCard>
  );
}
